import * as moment from "moment";
import * as createjs from "@createjs/core";
import * as VesselUtil from "@/utils/VesselUtil";
import _ from 'lodash';
import {AiseaApiFactory} from "@/api/aisea/apiFactory";
import {HtmlUtil} from "@/utils/";

const EnterpriseVesselApi = AiseaApiFactory.get("enterpriseVessel");
const EnterpriseUserApi = AiseaApiFactory.get("enterpriseUser");
const VoyageHistoryApi = AiseaApiFactory.get("voyageHistory");
const EnterpriseVoyageHistoriesApi = AiseaApiFactory.get("enterpriseVoyageHistories");

export default {
  async getLastPosition(_, vesselId) {
    let res = await VoyageHistoryApi.getLastPosition(vesselId);

    return res;
  },
  async getSearchInfo({ commit }) {
    let request = {limit: 9999};
    let res1 = await EnterpriseVesselApi.search(request);
    let res2 = await EnterpriseUserApi.search(request);

    commit("setSearchVessels", res1.data.vessels);
    commit("setSearchUsers", res2.data.users);
  },
  updateReady: (context, flag) => {
    context.commit("setReady", flag);
  },
  addLoadedLayer: (context, layerName) => {
    context.commit("addLoadedLayer", layerName);
  },
  clear: context => {
    context.commit("clear");
  },
  updateTick: context => {
    context.commit("updateTick", true);
  },
  createTicker: (context, map) => {
    // 初回位置を調整
    let mvp = context.state.my_vessel_positions;
    let pos = mvp.get(0);
    if (pos) {
      context.commit("setMapCenter", {
        lat: pos.lat,
        lon: pos.lon
      });
    }

    createjs.Ticker.framerate = 1;
    createjs.Ticker.addEventListener("tick", function (event) {
      if (!event.paused) {
        if (!context.state.tick) context.dispatch("updateTick");
        let ct = context.state.current_time;
        const st = context.state.start_time;
        const isReverse = context.state.history.isReverse;
        // 最後まで行ったら停止
        if (ct >= context.state.end_time && !isReverse) {
          context.dispatch("playTicker", false);
          return;
        }

        // 最初に戻ったら停止
        if (ct == st && isReverse) {
          context.dispatch("playTicker", false);
          return;
        }

        // マップの描画位置を調整
        context.commit("setMapInfo", {
          south_west: map.getBounds().getSouthWest(),
          north_east: map.getBounds().getNorthEast()
        });

        let now;
        if (isReverse) {
          now = ct - 1;
        } else {
          now = ct + 1;
        }

        context.commit("setCurrentTime", now);
        if ((((ct - st) + context.state.base_index) % (context.state.base_index + 1000)) == 0) {
          context.dispatch("changeSlider", {currentTime: now, refresh: true});
        } else {
          context.dispatch("updateMovementRecordList");
        }
      }
    });
    createjs.Ticker.timingMode = createjs.Ticker.RAF_SYNCHED;
    createjs.Ticker.paused = context.state.is_pause;
  },
  playTicker: (context, isPlay) => {
    let isPause = !isPlay;
    createjs.Ticker.paused = isPause;
    context.commit("setPause", isPause);
  },
  setFPS: (context, fps) => {
    createjs.Ticker.framerate = fps;
    context.commit("updateFPS", fps);

    context.dispatch("playTicker", true);
  },
  clearMyVesselWake: context => {
    context.commit("clearMyVesselWake");
  },
  getVoyageHistorySummary: context => {
    VoyageHistoryApi.getVoyageHistorySummary().then(response => {
      context.commit("setVoyageHistorySummary", response.data);
    });
  },
  getEnterpriseVoyageHistories: (context, params) => {
    EnterpriseVoyageHistoriesApi.getEnterpriseVoyageHistories(params).then(response => {
      let voyageHistories = response.data
      voyageHistories.summaries = response.data.summaries.map(element => {
        if (element.properties) {
          let historyProperties = HtmlUtil.htmlEscape(element.properties)
          historyProperties = JSON.parse(historyProperties)
          return {...element, properties: historyProperties}
        } else {
          return element
        }
      })
      context.commit("setEnterpriseVoyageHistories", voyageHistories);
      context.commit("setPageable", voyageHistories.pageable);
    });
  },
  deleteVoyageHistory: context => {
    return VoyageHistoryApi.deleteVoyageHistory(context.state.deleteHistoryId)
      .then(() => {
        context.commit("setDeleteHistoryId", null);
      });
  },
  setCurrentTime: (context, time) => {
    context.commit("setCurrentTime", time);
  },
  getMyVesselPositions: (context, historyId) => {
    return VoyageHistoryApi.getVoyageHistory(historyId).then(response => {

      let records = [];
      let indexes = [];
      let wakes = [];
      let vessel = response.data.vessel;

      let points = response.data.vessel_positions;
      for (let i = 0; i < points.length; i++) {
        let data = points[i];
        data.diff = 0;
        let currentTime = new Date(data.datetime).getTime() / 1000;


        if (!data.heading || data.heading == 511) {
          let before = context.state.before_vessel_positions.get(vessel.id);

          if (before) {
            const {
              direction,
              velocity
            } = VesselUtil.getVectorWithLightWeight(
              {
                l: {
                  latitude: data.latitude,
                  longitude: data.longitude
                },
                t: currentTime
              },
              {
                l: {
                  latitude: before.lat,
                  longitude: before.lon
                },
                t: before.time
              }
            );

            data.heading = direction;
            data.velocity = velocity;
            data.diff = before.time - currentTime;
          }
        }

        if (!data.direction && (data.heading && data.heading != 511)) {
          data.direction = data.heading;
        }

        let icon = VesselUtil.getSymbolIconNameLightWeight(Number(vessel.cat.id), data.velocity);

        let record = {
          d: data.direction,
          h: data.heading,
          lat: data.latitude,
          lon: data.longitude,
          time: currentTime,
          v: data.velocity,
          vessel_id: vessel.id,
          diff: data.diff,
          icon: icon,
          vessel: vessel,
          l: [data.longitude, data.latitude],
          f: {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [data.longitude, data.latitude]
            },
            properties: {
              rotate: data.heading,
              icon: icon,
              category: vessel.cat.id
            }
          }
        };

        records.push(record);
        indexes.push(currentTime);
        wakes.push([data.longitude, data.latitude]);
        context.commit("setBeforeVesselPosition", record);
      }

      let startedAt = moment(response.data.started_at);
      let endedAt = moment(response.data.ended_at);
      let unix = startedAt.unix();
      let duration = moment.duration(endedAt.diff(startedAt));

      context.commit("setVoyageHistory", {
        started_at: response.data.started_at,
        ended_at: response.data.ended_at,
        total_seconds: duration.asSeconds(),
        vessel_id: vessel.id
      });

      Object.freeze(records);
      Object.freeze(indexes);
      Object.freeze(wakes);
      context.commit("setMyVesselPositionAll", records);
      context.commit("setMyVesselPositions", records.slice(0, 1000));
      context.commit("setMaxIndex", records.length)
      context.commit("setCurrentTime", unix); // Epoc秒
      context.commit("setStartTime", unix); // Epoc秒
      context.commit("setEndTime", endedAt.unix()); // Epoc秒
      context.commit("setMyVesselPositionIndexes", indexes);
      context.commit("setMyVesselWakeAll", wakes);

      return response.data;
    });
  },
  getLocationSearch: (
    context,
    {
      endedAt,
      northEastLatitude,
      northEastLongitude,
      southWestLatitude,
      southWestLongitude,
      startedAt,
      ignoreVesselIds
    }
  ) => {
    return VoyageHistoryApi.getVoyageHistoryLocationSearch(
      endedAt,
      northEastLatitude,
      northEastLongitude,
      southWestLatitude,
      southWestLongitude,
      startedAt,
      ignoreVesselIds
    ).then(response => {
      let records = [];
      let mapRecords = {};
      let points = response.data.points;
      if (points.length == 0) return;
      for (let i = 0; i < points.length; i++) {
        let data = points[i];
        data.diff = 0;
        let currentTime = new Date(data.t).getTime() / 1000;
        let vessel = response.data.vessels[data.v_id];

        if (!data.h || data.h == 511) {
          let before = context.state.before_vessel_positions.get(data.v_id);
          if (before) {
            const {
              direction,
              velocity
            } = VesselUtil.getVectorWithLightWeight(
              {
                l: {
                  latitude: data.lat,
                  longitude: data.lon
                },
                t: currentTime
              },
              {
                l: {
                  latitude: before.lat,
                  longitude: before.lon
                },
                t: before.time
              }
            );

            data.h = direction;
            data.v = velocity;
            data.diff = before.time - currentTime;
          }
        }

        if (!data.d && (data.h && data.h != 511)) {
          data.d = data.h;
        }
        let icon = VesselUtil.getSymbolIconNameLightWeight(Number(vessel.cat.id), data.v);
        let record = {
          d: data.d,
          h: data.h,
          lat: data.lat,
          lon: data.lon,
          time: currentTime,
          v: data.v,
          vessel_id: data.v_id,
          diff: data.diff,
          icon: icon,
          vessel: vessel,
          l: [data.lon, data.lat],
          f: {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: [data.lon, data.lat]
            },
            properties: {
              rotate: data.h,
              icon: icon,
              category: vessel.cat.id
            }
          }
        };

        records.push(record);
        mapRecords[record.vessel_id] = record;
      }
      context.commit("mergeVesselPositions", records);
      context.commit("mergeBeforeVesselPositions", mapRecords);
    });
  },
  changeSlider: async (context, currentTime) => {
    let index;
    let refresh = false;
    if (typeof currentTime == 'object') {
      refresh = true;
      currentTime = currentTime.currentTime;
    }

    for (let ct = currentTime; ct < context.state.end_time; ct++) {
      index = context.state.my_vessel_position_indexes.indexOf(ct);
      if (index > 0) break;
    }

    if (!context.state.my_vessel_positions.get(index) || refresh) {
      const records = context.state.my_vessel_position_all;
      let my_vessel_positions = records.slice(index, index + 1000);
      context.commit("setMyVesselPositions", Object.freeze(my_vessel_positions));
      context.commit("setBaseIndex", index - 1);
      context.commit("setBackupIndexWake", 0);
      context.commit("setBackupIndexMyPos", 0);
      context.commit("clearMyVesselWake");
    } else {
      context.commit("setBackupIndexMyPos", index);
    }

    context.commit("setMyVesselWake", context.state.my_vessel_wake_all.slice(0, index));
    context.dispatch("updateMovementRecordList");
  },
  changeSliderStatus: async (context, bool) => {
    context.commit("setChangeSliderStatus", bool);
  },
  updateMovementRecordList: (context) => {
    let currentTime = context.state.current_time;
    let map = {};
    const vesselPositions = context.state.vessel_positions;

    // 他船
    for (let i = context.state.backup_index.other_pos; i < vesselPositions.size; i++) {
      let record = vesselPositions.get(i);
      if (record.time <= currentTime + 1) {
        map[record.vessel_id] = record;
      } else if (record.time > currentTime + 1) {
        context.commit("setBackupIndexOtherPos", i + 1);
        break;
      }
    }

    const myVesselPositions = context.state.my_vessel_positions;
    // 自船
    for (let i = context.state.backup_index.my_pos; i < myVesselPositions.size; i++) {
      let record = myVesselPositions.get(i);
      if (i === 0 || record.time <= currentTime + 1) {
        map[record.vessel_id] = record;

        let location = {
          lat: record.lat,
          lon: record.lon
        };
        context.commit("setMapCenter", location);
        context.commit("addMyVesselWake", record.l);
      } else if (record.time > currentTime + 1) {
        context.commit("setBackupIndexMyPos", i);
        break;
      }
    }

    // 古い情報を破棄
    let oldMap = context.state.movement_vessels;

    // GCはcurrentTimeをベースに指定間隔(gc_intervalの値)ごとに実行する
    if (context.state.gc_time === 0 || ((currentTime - context.state.gc_time) % context.state.gc_interval) == 0) {
      for (const record of oldMap) {
        let diff = currentTime - record[1].time;

        if (diff > 60 * 10) {
          oldMap = oldMap.remove(record[1].vessel.id);
        } else {
          let updateRecord = _.cloneDeep(record[1]);
          updateRecord.diff = diff;
          let icon = VesselUtil.getSymbolIconNameLightWeight(Number(record[1].vessel.cat.id), updateRecord);
          updateRecord.icon = icon;
          oldMap = oldMap.set(record[1].vessel.id, updateRecord);
          updateRecord = null;
        }
      }
      context.commit("setGcTime", currentTime);
    }

    // 画面外部にいる船舶を非表示
    context.commit("setMovementVessels2", oldMap.merge(map));
    oldMap = null;
    map = null;
  },
  selectPlayHistoryId: (context, historyId) => {
    context.commit("setPlayHistoryId", historyId);
  },
  setDeleteHistoryId: (context, historyId) => {
    context.commit("setDeleteHistoryId", historyId);
  },
  setHistoryPreviousTime: (context, payload) => {
    context.commit("setHistoryPreviousTime", payload);
  },
  setHistoryPlayVessels: (context, payload) => {
    context.commit("setHistoryPlayVessels", payload);
  },
  setHistoryWakes: (context, payload) => {
    context.commit("setHistoryWakes", payload);
  },
  setPlaySpeed: (context, payload) => {
    context.commit("setPlaySpeed", payload);
  },
  setReverse: (context, payload) => {
    context.commit("setReverse", payload);
  },
  clearHistory: context => {
    context.commit("clearHistory");
  },
  clearBackupIndex: context => {
    context.commit("setBackupIndexWake", 0);
    context.commit("setBackupIndexMyPos", 0);
    context.commit("setBackupIndexOtherPos", 0);
    context.commit("clearMyVesselWake");
  },
  setVoyageHistoryProgressMax: (context, payload) => {
    context.commit("setVoyageHistoryProgressMax", payload);
  },
  setVoyageHistoryProgressValue: (context, payload) => {
    context.commit("setVoyageHistoryProgressValue", payload);
  },
  setStep: (context, payload) => {
    context.commit("setStep", payload);
  },
  async resetVoyageHistoryListState({ commit }) {
    commit("RESET_VOYAGE_HISTORY_STATE");
    commit("RESET_PAGEABLE_STATE");
  }
};
